var React = require('react');

function IconGlobe (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","stroke":"#000","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"4"},[React.createElement("circle",{"cx":"40.23","cy":"40.23","r":"38.23","key":0}),React.createElement("path",{"d":"m40.23 2v76.46","key":1}),React.createElement("path",{"d":"m2 40.23h76.46","key":2}),React.createElement("path",{"d":"m72.07 19.13c-8.59 3.54-19.56 5.66-31.52 5.66-12.21 0-23.4-2.21-32.06-5.89","key":3}),React.createElement("path",{"d":"m8.53 61.54c8.55-3.54 19.47-5.66 31.38-5.66 12.17 0 23.3 2.21 31.93 5.89","key":4}),React.createElement("path",{"d":"m31.18 77.4a64.17 64.17 0 0 1 -11.3-36.89 64 64 0 0 1 11.76-37.51","key":5}),React.createElement("path",{"d":"m49.16 3a64.3 64.3 0 0 1 11.3 37 64.16 64.16 0 0 1 -11.76 37.53","key":6})]));
}

IconGlobe.defaultProps = {"viewBox":"0 0 80.46 80.46"};

module.exports = IconGlobe;

IconGlobe.default = IconGlobe;
